import { ProgressCircleIcon } from '@/components/icons/progressCircle'
import { cn } from '@/utils/cn'
import { formatDecimalToPercentage, formatTokenValue } from '@vaultsfyi/common/utils'
import { Tooltip, TooltipContent, type TooltipProps } from './tooltip'

interface AllocationShareTooltipProps {
  allocation: number
  supplyAssets: string
  assetSymbol: string
  assetDecimals: number
  marketName: string
}

type Props = AllocationShareTooltipProps & Pick<TooltipProps, 'className' | 'tabIndex'>

export const AllocationShareTooltip = ({
  allocation,
  supplyAssets,
  assetSymbol,
  assetDecimals,
  marketName,
  className,
  tabIndex,
}: Props) => {
  const fillPercent = Math.max(0, Math.min(100, allocation * 100))
  const formattedAllocation = formatTokenValue({ value: supplyAssets, decimals: assetDecimals })
  const formattedShare = formatDecimalToPercentage(allocation, { fractionDigits: 0 })

  return (
    <Tooltip
      tabIndex={tabIndex}
      className={cn(
        'relative z-[1] flex min-h-7 w-fit min-w-7 items-center justify-center rounded-full border border-transparent bg-transparent',
        'hocus:border-border hocus:bg-surface',
        className
      )}
    >
      <ProgressCircleIcon progress={fillPercent} size={28} className="text-accent" />
      <TooltipContent side="top" align="start">
        <p className="font-semibold">{formattedShare} of vault assets</p>
        <p>
          {formattedAllocation} {assetSymbol} allocated to {marketName}
        </p>
      </TooltipContent>
    </Tooltip>
  )
}
